import { Component, OnInit, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit {

  @Input()
  shrink: boolean

  constructor(
    private el: ElementRef
  ) { }

  ngOnInit() {
    
  }

}
